import { useLayoutEffect } from "react";
import { Outlet } from "react-router";

import Header from "./setup/header";
import Footer from "./setup/footer";
import consumerStyle from "./consumer.module.css";

import SnackBarProvider from "./snackbar/provider";
import { SocketProvider } from "context/SocketContext";

export default function Consumer(props) {

    useLayoutEffect(() => {
		document.body.classList.add(consumerStyle['body']);

		document.getElementById("root").classList.add(consumerStyle['root']);
	}, []);

	return (
		<div
			className={consumerStyle['consumer']}
			style={{
				height: window.visualViewport.height,
			}}
		>
			<SocketProvider>
				<SnackBarProvider>
					<Header></Header>

                    <div
                        style={{
                            position: "absolute",
                            left: "0px",
                            top: "6vh",
                            width: "100%",
                            height: "94vh"
                        }}
                    >
                        <div
                            style={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                                overflowY: "auto"
                            }}
                        >
                            <Outlet></Outlet>
                            <Footer></Footer>
                        </div>
                    </div>
				</SnackBarProvider>
			</SocketProvider>
		</div>
	);
}
